const Env = (name: string, defaultvalue?: string) => {
	// eslint-disable-next-line no-underscore-dangle
	const variable = window._env_[name];

	if (!variable) return defaultvalue;

	return variable;
};

// eslint-disable-next-line no-underscore-dangle
const GetAllEnvironmentVariables = () => window._env_;
const IsDevelopmentMode = () => Env('MODE') === 'DEVELOPMENT';

export default Env;
export { GetAllEnvironmentVariables, IsDevelopmentMode };
